import Navbar from "../assets/Navbar";
import CardDesign from "../components/cardDesign";
import FooterSection from "assets/Footer";
import TrendingProducts from "components/dashboardComponents/trendingProducts";
import RevealOnScroll from "components/RevealOnScroll";
import ScrollToTopButton from "components/ScrollToTopButton";
import ShimmerFreeDelivery from "components/shimmer/ShimmerFreeDelivery";
import useAllProductsData from "hook/useAllProductsData";
import { useState, useEffect } from "react";
import {
  FaStar,
  FaTag,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const NewProductsFullPage = () => {
  const { allProducts, loading, error } = useAllProductsData();
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="bg-gray-100 flex flex-col min-h-[100dvh]">
      <Navbar />
      <main className="mx-auto w-full">
        <div>
          {!loading && !error && allProducts.length > 0 && (
            <>
              <RevealOnScroll>
                <section className="overflow-hidden mb-5 bg-slate-900 text-white shadow-lg sm:px-10">
                  <div className="relative">
                    <div className="absolute inset-0">
                      <img
                        src="https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=1400&q=80"
                        alt="New arrivals banner"
                        className="h-full w-full object-cover opacity-25"
                      />
                      <div className="absolute inset-0 bg-gradient-to-r from-emerald-950/95 via-slate-900/85 to-cyan-900/70" />
                    </div>
                  </div>
                  <div className="relative p-5 sm:p-7">
                    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
                      <div>
                        <h1 className="text-2xl font-extrabold sm:text-3xl">
                          New Products
                        </h1>
                        <p className="mt-2 max-w-xl text-sm text-slate-200 sm:text-base">
                          Fresh arrivals across categories — updated regularly
                          so you never miss a new drop.
                        </p>
                      </div>
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-xs inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2">
                          <FaStar />
                          New Arrivals
                        </span>
                        <span className="text-xs inline-flex items-center gap-2 rounded-full border border-white/15 bg-white text-slate-900 px-3 py-2">
                          <FaTag />
                          Just Landed
                        </span>
                      </div>
                    </div>
                  </div>
                </section>
              </RevealOnScroll>
            </>
          )}
        </div>
      </main>
      <div className="container mx-auto relative">
        {loading && <ShimmerFreeDelivery />}
        <CardDesign likeData={allProducts} />
      </div>
      {/* <div className="container mx-auto relative">
        {!loading && !error && allProducts.length > 0 && (
          <div className="mb-3">
            <div className="flex items-center justify-center w-full px-4 md:my-5 my-3">
              <span className="md:text-2xl text-xl md:font-bold font-extrabold text-black tracking-wide pt-3 pb-1">
                NEW PRODUCTS
              </span>
            </div>
            <CardDesign likeData={allProducts} />
          </div>
        )}
      </div> */}
      <TrendingProducts />
      <FooterSection />
      {showScrollTop && (
        <ScrollToTopButton />
      )}
    </div>
  );
};

export default NewProductsFullPage;
